<div class="property-display-box">
    <p class="property-display-label">{{ label | translate }}</p>
    <div class="flex-spacer"></div>
    <p class="property-display-value"><ng-content></ng-content></p>
</div>